/**
 * `Alert.alert` no navegador.
 *
 * O react-native-web implementa `Alert` como uma função vazia: a chamada não
 * lança, não mostra nada e não chama botão nenhum. As quatro perguntas do app
 * ("Sair mesmo assim?", "Fechar o caixa?") sumiriam em silêncio, e a mais
 * perigosa delas é justamente a que avisa de validação ainda não enviada.
 *
 * Todas têm a mesma forma — um botão de cancelar e um de seguir —, que é o
 * que o `confirm` do navegador sabe fazer. O texto do botão de seguir entra na
 * pergunta, porque o `confirm` só sabe dizer OK.
 */

import {Alert, type AlertButton} from 'react-native';

function alertaDoNavegador(
  titulo: string,
  mensagem?: string,
  botoes?: AlertButton[],
): void {
  const cancelar = botoes?.find(b => b.style === 'cancel');
  const seguir = botoes?.find(b => b !== cancelar);
  const texto = [titulo, mensagem].filter(Boolean).join('\n\n');

  if (!seguir) {
    window.alert(texto);
    cancelar?.onPress?.();
    return;
  }

  const pergunta = seguir.text ? `${texto}\n\nOK = ${seguir.text}` : texto;
  if (window.confirm(pergunta)) {
    seguir.onPress?.();
  } else {
    cancelar?.onPress?.();
  }
}

export function instalarAlerta(): void {
  Alert.alert = alertaDoNavegador as typeof Alert.alert;
}
